export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6750.0b160422.jpg";